<template>
  <div id="combat_groupStage" v-show="currThemeObj">
    <div class="teamList_area" ref="teamListArea">
      <template v-if="!isNotDataFlag">
        <!-- <span class="groupTitle" v-text="groupTitle"></span> -->
        <div
          class="compreSportsMeet_table_item"
          v-for="(table, index) in teamListGroup"
          :key="index"
        >
          <compreSportsMeet_table
            :currThemeObj="currThemeObj"
            :currCid="currCid"
            :currSid="currSid"
            :tableMode="tableMode"
            :parentWidthPx="compreSportsMeet_table_parentWidthPx"
            :isScrollFlag="table.isScrollFlag"
            :variableColWidthVw="table.variableColWidthVw"
            :tableCellDefaultWidthVw="table.tableCellDefaultWidthVw"
            :defaultWidthVwNum="table.defaultWidthVwNum"
            :tableColumnData="table.tableColumnData"
            :tableData="table.tableData"
            v-show="
              compreSportsMeet_table_parentWidthPx && teamListGroup.length >= 0
            "
          ></compreSportsMeet_table>
          <span
            v-if="table.analysisItemId"
            class="compreSportsMeet_table_publishBtn"
            @click="formatThemeActJson(table)"
          >
            <svg
              t="1692698307306"
              class="publishBtn_icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="9670"
              width="50%"
              height="50%"
            >
              <path
                d="M853.333333 533.333333a32 32 0 0 1 64 0v266.666667c0 64.8-52.533333 117.333333-117.333333 117.333333H224c-64.8 0-117.333333-52.533333-117.333333-117.333333V256c0-64.8 52.533333-117.333333 117.333333-117.333333h277.333333a32 32 0 0 1 0 64H224a53.333333 53.333333 0 0 0-53.333333 53.333333v544a53.333333 53.333333 0 0 0 53.333333 53.333333h576a53.333333 53.333333 0 0 0 53.333333-53.333333V533.333333z m-42.058666-277.333333l-89.792-95.402667a32 32 0 0 1 46.613333-43.861333l140.544 149.333333C927.861333 286.485333 913.376 320 885.333333 320H724.704C643.029333 320 576 391.210667 576 480v192a32 32 0 1 1-64 0V480c0-123.296 94.784-224 212.704-224h86.570667z"
                p-id="9671"
              ></path>
            </svg>
          </span>
        </div>
      </template>
    </div>
    <cup_notData
      v-if="isNotDataFlag"
      :className="'relativePtb30'"
    ></cup_notData>
  </div>
</template>

<script>
// import matchList_mock from './matchList_mock.json'
import cup_base_data_mixin from '@mixins/cup_base_data'
import single_findAnalysisItem_data_mixin from '@mixins/single_findAnalysisItem_data'
import cup_notData from '@components/base/NO_DATA.vue'
import compreSportsMeet_table from '@components/platfromBase/compreSportsMeet/table/multiLevelFold_table.vue'
export default {
  name: 'combat_groupStage',
  mixins: [cup_base_data_mixin, single_findAnalysisItem_data_mixin],
  components: {
    compreSportsMeet_table,
    cup_notData,
  },
  props: {
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
    datas: {
      type: Object,
      default: () => ({
        dataList: [],
        statisticalInfos: [],
      }),
    },
  },
  data() {
    return {
      tableMode: 'combat_groupStage',
      groupTitle: '',
      compreSportsMeet_table_parentWidthPx: 0,
      teamListGroup: null,
      dataItemId: null,
      isNotDataFlag: false,
      themeTemplateType: 18,
    }
  },
  watch: {
    // currSportsDetail: {
    //   handler(newVal, oldVal) {
    //     console.debug('重新刷新数据1:', newVal, oldVal)
    //     if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
    //       this.init()
    //     }
    //   },
    //   //   immediate: true,
    //   deep: true,
    // },
    datas: {
      handler(newVal, oldVal) {
        console.debug('combat_groupStage datas 重新刷新数据:', newVal, oldVal)
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          this.init()
        }
      },
      // immediate: true,
      deep: true,
    },
  },
  created() {
    this.init()
    console.debug('combat_groupStage:', this.datas)
  },
  mounted() {
    // console.debug(this.$refs)
    this.compreSportsMeet_table_parentWidthPx =
      this.$refs.teamListArea.offsetWidth
    window.addEventListener('resize', () => {
      this.onResizeEvent()
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', () => {
      this.onResizeEvent()
    })
  },
  methods: {
    async init() {
      // console.debug('currSportsDetail:', this.currSportsDetail)
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      this.makeLeagueTable()
      this.makeAnalysisItemParams(this.themeTemplateType)
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    makeAnalysisItemParams(themeTemplateType) {
      // 每个页面单独设置不同函数
      this.findAnalysisItemParams = {
        sportType: 'compreSportsMeet',
        templateType: themeTemplateType,
        cid: this.currCid,
        sid: this.currSid,
        did: this.currSportsDetail.sportsId,
        eid: this.currSportsDetail.eventId,
        pid: 0,
        mid: 0,
      }
      if (this.initSingleFindAnalysisItem) {
        this.initSingleFindAnalysisItem(this.findAnalysisItemParams)
      }
    },
    findAnalysisItemCallback(resData) {
      // let themeAnalysisItemIdArr = []
      console.debug('resData:', resData)
      let jsonArr = []
      if (resData && resData.length > 0) {
        this.themeList = resData.map((item) => {
          // themeAnalysisItemIdArr.push(item.analysisItemId)
          // console.debug(`aa: ${item}`)
          jsonArr.push(item.json)
          item.actJson = JSON.parse(item.json)
          item.renderData = null
          return item
        })
        this.themeItem = this.themeList[0]
        this.shareDataAddThemeItem(this.themeItem)
      } else {
        this.themeList = []
        this.themeItem = null
      }
    },
    formatThemeActJson(table) {
      if (!this.themeItem) return
      // 主题不同，有些地方需要特殊处理
      // 传参组id
      let keyArrActJson = []
      let newThemeItem = JSON.parse(JSON.stringify(this.themeItem))
      newThemeItem.sportsId = newThemeItem.disciplineId
      newThemeItem.title = table.title
      newThemeItem.actJson = JSON.parse(newThemeItem.json)
      keyArrActJson = Object.keys(newThemeItem.actJson)
      keyArrActJson.forEach((keyItem) => {
        newThemeItem.actJson[keyItem] = table[keyItem]
      })
      console.debug('newThemeItem:', newThemeItem, table, this.teamListGroup)
      this.clickPublicTheme(newThemeItem)
    },
    clickPublicTheme(themeItem) {
      // 分享主题
      let newThemeItem = themeItem
      console.debug('newThemeItem:', newThemeItem)
      // 需要加【篮球-预赛B组积分榜】
      newThemeItem.analysisItemName = newThemeItem.title
      window.mixtmtBase_eventBus.$emit('publicThemeDialogEvent', {
        flag: true,
        themeItem: newThemeItem,
      })
    },
    onResizeEvent() {
      if (this.$refs.teamListArea) {
        this.compreSportsMeet_table_parentWidthPx =
          this.$refs.teamListArea.offsetWidth
      } else {
        console.debug('dom 不存在')
      }
    },
    makeLeagueTable() {
      const datas = this.datas
      console.debug('this.isNotDataFlag:', this.isNotDataFlag, datas)
      if (datas && datas.dataList && datas.dataList.length > 0) {
        this.isNotDataFlag = false
      } else {
        this.isNotDataFlag = true
      }
      let table_header = datas.statisticalInfos
      // let keyArrActJson = []
      // if (this.themeItem) {
      //   table_header = this.themeItem.statisticsModels
      //     ? this.themeItem.statisticsModels
      //     : null
      //   this.groupTitle = this.themeItem.analysisItemName
      //   this.themeItem.actJson = JSON.parse(this.themeItem.json)
      //   keyArrActJson = Object.keys(this.themeItem.actJson)
      // }
      let otherTableColumnData = []
      if (table_header) {
        otherTableColumnData = table_header.map((keyItem) => {
          return {
            prop: keyItem.statisticalEn,
            label: keyItem.name,
            widthVw: 5.55,
          }
        })
      }
      console.debug(
        'groupList:',
        otherTableColumnData,
        this.themeItem,
        table_header
      )
      if (!this.isNotDataFlag) {
        this.teamListGroup = datas.dataList
          ? datas.dataList.map((val) => {
              const tableColumnData = [].concat(
                [
                  {
                    prop: 'rankNum-teamLogo-teamName',
                    label: val.groupName,
                    widthVw: 25.42,
                    className: 'columnNumLogoNameClass',
                    fixed: 'left',
                  },
                ],
                otherTableColumnData,
                [
                  {
                    prop: '',
                    label: '',
                    widthVw: 4.16,
                  },
                ]
              )
              let singleTable = {
                groupCode: val.groupCode ? val.groupCode : '',
                groupName: val.groupName ? val.groupName : '',
                isScrollFlag: false,
                variableColWidthVw: 25.42, // 可变化的宽度
                tableCellDefaultWidthVw: 5.55, // 默认宽度 ,
                defaultWidthVwNum: otherTableColumnData
                  ? otherTableColumnData.length
                  : 0,
                tableColumnData,
                // tableColumnData: [
                //   {
                //     prop: 'rankNum-teamLogo-teamName',
                //     label: val.data.seriesName,
                //     widthVw: 25.42,
                //     className: 'columnNumLogoNameClass',
                //     fixed: 'left',
                //   },
                //   {
                //     prop: 'matchesPlayed',
                //     label: '场次',
                //     widthVw: 5.55,
                //   },
                //   {
                //     prop: 'matchesWon',
                //     label: '胜',
                //     widthVw: 5.55,
                //   },
                // ],
                tableData: val.ranks
                  ? val.ranks.map((team) => {
                      team.team_id = team.organisationCode
                      team.team_name = team.organisationName
                      team.team_logo = team.organisationLogo
                      team.rank_num = team.rankNum
                      return team
                    })
                  : [],
              }
              return singleTable
            })
          : []
      } else {
        this.teamListGroup = []
      }
      console.debug('teamListGroup:', this.teamListGroup)
    },
    shareDataAddThemeItem(themeItem) {
      if (!this.isNotDataFlag && this.teamListGroup.length > 0 && themeItem) {
        console.debug('this.teamListGroup 1:', this.teamListGroup)
        this.teamListGroup = this.teamListGroup.map((orginTableItem) => {
          const groupTitle = themeItem.analysisItemName
          let singleTableTheme = {
            analysisItemId: themeItem.analysisItemId,
            title: `${groupTitle}-${orginTableItem.groupName}积分榜`,
          }
          return Object.assign(orginTableItem, singleTableTheme)
        })
        console.debug('this.teamListGroup:', this.teamListGroup)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#combat_groupStage {
  padding-bottom: 2.778vw;
  .teamList_area {
    width: 100%;
    padding: 2.083vw 0 0 0;
    .groupTitle {
      display: block;
      padding-bottom: 0.972vw;
      font-size: 1.388vw;
      line-height: 1.944vw;
      font-weight: bold;
      color: var(--mixtmt_greyColor3);
    }
    .compreSportsMeet_table_item {
      position: relative;
      padding-bottom: 2.083vw;
      .compreSportsMeet_table_publishBtn {
        position: absolute;
        right: 0;
        top: 0;
        z-index: 2;
        width: 3.2vw;
        height: 3.332vw;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        svg.publishBtn_icon {
          fill: var(--mixtmt_whiteColor);
        }
      }
    }
  }
}
.mixtmt_pc #combat_groupStage,
.mixtmt_ipad #combat_groupStage {
}
.mixtmt_pc #combat_groupStage {
  .teamList_area {
    .compreSportsMeet_table_item {
      .compreSportsMeet_table_publishBtn {
        cursor: pointer;
        &:hover {
          svg.publishBtn_icon {
            fill: var(--mixtmt_greyColor4);
          }
        }
      }
    }
  }
}
</style>
